<div class="ws">
  <div (click)="wsAutobahnConnect()"
       [class.ok]="wsAutobahnActive"
       [class.nok]="!wsAutobahnActive"
       class="ws__indicator"
       matTooltip="{{wsAutobahnActive ? 'live update OK' : 'live update NOK'}}">
  </div>
</div>
